import { motion } from "framer-motion";

// Masked line-by-line reveal. Pass an array of strings (lines).
export const RevealHeading = ({ lines, className = "", delay = 0, testId }) => {
  return (
    <span className={className} data-testid={testId} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{
              duration: 1.15,
              ease: [0.16, 1, 0.3, 1],
              delay: delay + i * 0.12,
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

// Scroll-triggered fade + rise wrapper
export const Reveal = ({ children, className = "", delay = 0, y = 40, once = true }) => {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay }}
    >
      {children}
    </motion.div>
  );
};
